import logo from "./logo.svg";
import "./App.css";
import "boxicons/css/boxicons.min.css";
import Navbar from "./component/Sidebar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Dashboard";
import Destination from "./pages/Destination";
import Hotels from "./pages/Hotels";
import PrefferPartner from "./pages/PrefferPartner";
import TravelPartner from "./pages/TravelPartner";
import VacationBeingHere from "./pages/VacationBeingHere";
import ClientTestimonial from "./pages/ClientTestimonial";
import Users from "./pages/Users";
import InquiryDetails from "./pages/InquiryDetails";
import PaymentDetails from "./pages/PaymentDetails";
import Login from "./pages/Login";
import { useCookies } from "react-cookie";
import PrivateRoute from "./utils/PrivateRoute";

function App() {
  const [cookies] = useCookies(["token"]);

  return (
    <div className="App">
      <Router>
        <PrivateRoute>
          <Navbar />
        </PrivateRoute>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <Users />
              </PrivateRoute>
            }
          />
          <Route
            path="/destination"
            element={
              <PrivateRoute>
                <Destination />
              </PrivateRoute>
            }
          />
          <Route
            path="/hotels"
            element={
              <PrivateRoute>
                <Hotels />
              </PrivateRoute>
            }
          />
          <Route
            path="/prefferPartner"
            element={
              <PrivateRoute>
                <PrefferPartner />
              </PrivateRoute>
            }
          />
          <Route
            path="/travelPartner"
            element={
              <PrivateRoute>
                <TravelPartner />
              </PrivateRoute>
            }
          />
          <Route
            path="/vacationBeingHere"
            element={
              <PrivateRoute>
                <VacationBeingHere />
              </PrivateRoute>
            }
          />
          <Route
            path="/clientTestimonial"
            element={
              <PrivateRoute>
                <ClientTestimonial />
              </PrivateRoute>
            }
          />
          <Route
            path="/inquiryDetails"
            element={
              <PrivateRoute>
                <InquiryDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/paymentDetails"
            element={
              <PrivateRoute>
                <PaymentDetails />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
